import { render } from "./App.vue?vue&type=template&id=6fe7a46c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6fe7a46c&lang=css"

import exportComponent from "E:\\UiDesk\\laragon-5.0.0\\www\\click-to-call\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__